import React from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { Link } from "react-router-dom"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import { ACTIVITY_FEED_EVENT_TYPE } from "../../../state/activity-feed/ActivityFeedEventType"
import { Intl } from "../../../state/helpers/IntlProps"

type Props = {
    intl: Intl,
    activity: ActivityFeedEventSearchResult,
}

const messages = defineMessages({
    [ACTIVITY_FEED_EVENT_TYPE.SMS_RECEIVED]: {
        id: "dashboard.props.activity-feed.sms-received",
        defaultMessage: "text",
    },
    [ACTIVITY_FEED_EVENT_TYPE.CHAT_MESSAGE_RECEIVED]: {
        id: "dashboard.props.activity-feed.chat-received",
        defaultMessage: "chat",
    },
})


const ActivityFeedEventConversationMessageComponent = (props: Props) => {

    const parsedData = JSON.parse(props.activity.getObjectDataJson())
    const content = parsedData.content

    return (
        <>
            <div>
                <Link to={"/contacts/" + props.activity.getContactId() + "/details"}>
                    {props.activity.getContactName()}
                </Link>
                &nbsp;
                <FormattedMessage
                    id="props.activity-feed.message_info"
                    defaultMessage="sent a {type} message {user} in"
                    values={{
                        type: messages[props.activity.getActivityType()] ?
                            props.intl.formatMessage(messages[props.activity.getActivityType()]) : "",
                        user: props.activity.getCreatedByUserName() ? "to " + props.activity.getCreatedByUserName() : "",
                    }}
                />
                &nbsp;
                <Link to={"/" + props.activity.getObjectType() + "/" + props.activity.getObjectId() + "/edit"}>
                    {props.activity.getIdentifier()}
                </Link>
            </div>
            <div className={"row pl-3"}>
                <div className={"w-100 mt-1"}>
                    <blockquote className="blockquote mb-0 bg-light py-3">
                        <p className="mb-0">{content}</p>
                    </blockquote>
                </div>
            </div>
        </>
    )
}

export default injectIntl(ActivityFeedEventConversationMessageComponent)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventConversationMessageComponent.tsx